/* ARA Redesign — motion engine: smooth scroll + scroll-reveals.
   Dependency-optional: Lenis/GSAP/ScrollTrigger enhance if present; reveals work regardless.
   Hard gates: reduced-motion, coarse pointer, and Shopify theme editor (designMode). */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  window.ARA = window.ARA || {};
  window.ARA.reduced = reduced;

  /* ---- scroll reveals (always on; CSS handles reduced-motion) ---- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }) : null;

  function scan(root) {
    (root || document).querySelectorAll('.ara-reveal:not(.is-in)').forEach(function (el, i) {
      if (!el.style.getPropertyValue('--ara-d') && el.hasAttribute('data-stagger')) {
        el.style.setProperty('--ara-d', (i % 8 * 0.08) + 's');
      }
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---- Lenis smooth scroll (skipped on reduced/coarse/editor) ---- */
  function initLenis() {
    if (reduced || coarse || editor || !window.Lenis || window.ARA.lenis) return;
    /* overlay drawers/modals must keep native wheel scroll — Lenis honors this attribute per-event */
    document.querySelectorAll('sidebar-drawer, modal-box, .sidebar, .modal').forEach(function (el) {
      el.setAttribute('data-lenis-prevent', '');
    });
    var lenis = new window.Lenis({ lerp: 0.09, wheelMultiplier: 0.9, smoothWheel: true });
    window.ARA.lenis = lenis;
    if (window.gsap && window.ScrollTrigger) {
      lenis.on('scroll', window.ScrollTrigger.update);
      window.gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      window.gsap.ticker.lagSmoothing(0);
    } else {
      function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
    }
  }

  function boot() { scan(document); initLenis(); if (window.ScrollTrigger) window.ScrollTrigger.refresh(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', function () {
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    /* safety net: nothing may stay hidden if an observer misfires */
    setTimeout(function () {
      document.querySelectorAll('.ara-reveal:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 0) && r.bottom > 0) el.classList.add('is-in');
      });
    }, 3000);
  });

  /* re-scan when sections re-render in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  });
  window.ARA.scan = scan;
})();
